<div class="plansPage">

  <div class="plansLogo">
    <a
      [routerLink]="['/auth/login']"
      title="Startseite"
    >
      <img
        [src]="logoSrc || 'assets/logo.png'"
        alt="Logo"
      >
    </a>
  </div>

  <div class="stripeHint" *ngIf="!stripeConfigured">
    <mat-icon color="warn">info</mat-icon>
    <div>
      <h2>Stripe ist noch nicht eingerichtet</h2>
      <p>
        Hinterlegen Sie Ihren Stripe Publishable Key in der Konfiguration oder kontaktieren Sie uns für ein individuelles Angebot.
      </p>
    </div>
  </div>

  <div class="planStatus" *ngIf="statusLoading || paymentStatus">
    <div class="planStatus__header">
      <div class="planStatus__title">
        <mat-icon>verified_user</mat-icon>
        <div>
          <div class="label">Aktueller Plan</div>
          <div class="value">{{ getPlanDisplayName(paymentStatus) || 'Lade Status...' }}</div>
        </div>
      </div>
      <mat-progress-spinner
        *ngIf="statusLoading"
        diameter="18"
        mode="indeterminate"
        strokeWidth="3"
      ></mat-progress-spinner>
    </div>

    <div class="planStatus__body" *ngIf="paymentStatus">
      <span
        class="pill"
        [class.pill--active]="paymentStatus.active"
        [class.pill--inactive]="paymentStatus.active === false"
      >
        {{ paymentStatus.status || (paymentStatus.active ? 'aktiv' : 'nicht aktiv') }}
      </span>
      <span class="meta" *ngIf="paymentStatus.nextPaymentDate">
        N?chste Zahlung: {{ paymentStatus.nextPaymentDate | date: 'mediumDate' }}
      </span>
      <span class="meta" *ngIf="paymentStatus.subscriptionId">Subscription ID: {{ paymentStatus.subscriptionId }}</span>
    </div>
  </div>


  <div class="plansError" *ngIf="statusError">
    <mat-icon color="warn">warning</mat-icon>
    <span>{{ statusError }}</span>
  </div>

<div class="headline">
    <h1>Testen Sie noch heute unser MemberPort – einfach, sicher und flexibel.</h1>
    <div class="tabs">

    </div>
  </div>

  <div class="cards">
    <div
      class="planCard"
      *ngFor="let plan of plans"
      [class.recommended]="plan.recommended"
      [attr.aria-label]="plan.title + ' plan'"
    >
      <div class="recommendedBadge" *ngIf="plan.recommended">EMPFOHLEN</div>

      <div class="cardHeader">
        <h2 class="planTitle">{{ plan.title }}</h2>
        <div class="planSubtitle">{{ plan.subtitle }}</div>
      </div>

      <div class="priceRow">
        <div class="price">{{ plan.price }}</div>
        <div class="priceNote">{{ plan.priceNote }}</div>
      </div>

      <div class="ctaRow">
        <button
          class="btnPrimary"
          [ngClass]="plan.id === 'enterprise' ? 'ghost' : (plan.recommended ? 'strong' : 'light')"
          type="button"
          (click)="onPrimaryAction(plan)"
          [disabled]="loadingPlanId === plan.id"
        >
          <mat-progress-spinner
            *ngIf="loadingPlanId === plan.id"
            diameter="18"
            mode="indeterminate"
            strokeWidth="3"
          ></mat-progress-spinner>
          <span>{{ plan.ctaPrimary }}</span>
          <span class="visually-hidden" *ngIf="loadingPlanId === plan.id">Weiterleitung zu Stripe wird vorbereitet</span>
        </button>
      </div>

      <div class="divider"></div>

      <ul class="featureList">
        <li *ngFor="let f of plan.features">
          <span class="chev">&rsaquo;</span>
          <span class="txt">{{ f }}</span>
        </li>
      </ul>

      <div class="addOns" *ngIf="plan.addOns?.length">
        <div class="addOnsTitle">{{ plan.addOnsTitle }}</div>
        <ul>
          <li *ngFor="let a of plan.addOns">
            <span class="chev">&rsaquo;</span><span class="txt">{{ a }}</span>
          </li>
        </ul>
      </div>
      <div class="onPremNote" *ngIf="plan.id === 'enterprise'">
        Sie wollen die Anwendung <b>on Premise</b> laufen lassen?<br />
        Sprechen Sie uns gerne an.
      </div>
    </div>
  </div>

  <div class="plansError" *ngIf="errorMessage">
    <mat-icon color="warn">warning</mat-icon>
    <span>{{ errorMessage }}</span>
  </div>
</div>

<footer-login></footer-login>
